import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFire1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconFire1"><Path d="M19.75 13.8679C19.75 23.7053 4.25 23.7161 4.25 13.8679C4.25 6.4747 12 2.25 12 2.25C12 2.25 19.75 6.4747 19.75 13.8679Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><Path d="M15.75 17.4618C15.75 22.51 8.25 22.5155 8.25 17.4618C8.25 13.6679 12 11.5 12 11.5C12 11.5 15.75 13.6679 15.75 17.4618Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconFire1;
